<script>
  export let viewBox;
</script>

<svg on:click class="icon" viewBox="{viewBox}">
  <path d="M11.9 11.9H48v36.2H11.9V11.9z"></path>
</svg>
